import { Flex } from 'antd';

import {
  useAppSelector,
  useRequestTypeFinderById,
  useStatusFinderByNum,
  useUserPermissions,
} from '@Hooks/index';
import { useGetHrmRequestFormQuery } from '@Store/api/basicHrmApiSlice';
import { getModalRecordKey } from '@Store/selectors/modalSelector';

import { getResumptionWorkShiftDict } from '@Store/selectors/dictionarySelector';
import { Status } from '@Components/Base';
import fieldSource from '../FieldSource';

import { EditAction, FooterActions } from './components';

import styles from './view-mobile-form.module.css';
import { getLabel } from '../../../utils/resumingFrom';

interface RequestViewMobileFormProps {
  onEdit: (recordKey: string) => void;
  onDeleteRequest: (requestNo: string) => void;
  onSubmitRequest: (requestNo: string) => void;
  onCancelRequest: (requestNo: string) => void;
}

const RequestViewMobileForm: React.FC<RequestViewMobileFormProps> = ({
  onEdit,
  onDeleteRequest,
  onSubmitRequest,
  onCancelRequest,
}) => {
  const { findRequestType: findLeaveRequestType } =
    useRequestTypeFinderById('Leave');
  const { findStatus } = useStatusFinderByNum('Resumption');
  const requestId = useAppSelector(getModalRecordKey);
  const resumptionWorkShifts = useAppSelector(getResumptionWorkShiftDict);
  const permissions = useUserPermissions();
  const { data } = useGetHrmRequestFormQuery(requestId!, {
    skip: !requestId,
    refetchOnMountOrArgChange: true,
  });
  const { data: leaveReqData } = useGetHrmRequestFormQuery(
    String(data?.leaveTypeID),
    {
      skip: !data?.leaveTypeID,
      refetchOnMountOrArgChange: true,
    }
  );

  if (!data) return null;

  const resumingFromLabel = getLabel(
    leaveReqData,
    findLeaveRequestType,
    'DD/MM/YYYY'
  );
  const statusRequest = findStatus(data?.reqStatusId)?.codeDesc || '';

  const findWorkShiftLabel = (workShift: number): string =>
    resumptionWorkShifts.find((shift) => shift.codeNum === workShift)
      ?.codeDesc || '';

  return (
    <Flex vertical>
      <div className={styles.viewMobileForm}>
        {fieldSource(data, resumingFromLabel, findWorkShiftLabel).map(
          (item) => (
            <div className={styles.viewMobileItem} key={item.label}>
              <span>{item.label}</span>
              {item.label === 'Status' ? (
                <Status
                  className={styles.viewMobileItemValue}
                  text={findStatus(Number(item.value))?.codeDesc || ''}
                />
              ) : (
                <span className={styles.viewMobileItemValue}>{item.value}</span>
              )}
            </div>
          )
        )}
      </div>
      <EditAction handleEdit={() => onEdit(requestId)} status={statusRequest} />
      <FooterActions
        handleDeleteRequest={() => onDeleteRequest(requestId)}
        handleSubmitRequest={() => onSubmitRequest(requestId)}
        handleCancelRequest={() => onCancelRequest(requestId)}
        disabledCancelForm={!permissions.can('Cancel', 'Resumption')}
        disabledDeleteForm={!permissions.can('Delete', 'Resumption')}
        disabledSubmitForm={!permissions.can('Submit', 'Resumption')}
        status={statusRequest}
      />
    </Flex>
  );
};

export default RequestViewMobileForm;
